/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarColumnsAxisX: {
  name: 'bar-columns-axis-x';
  data: string;
} = {
  name: 'bar-columns-axis-x',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v7h3V9a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v10a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1V5Zm10 9h-3v5h3v-5Zm-5-1V5H5v14h3v-6Zm10 6V9h-3v10h3Z" fill="currentColor"/></svg>`,
};
